import { FC } from 'react'
import { GlobalNavigation } from 'src/features/globalNavigation/GlobalNavigation'
import { TemplateTabsHeader } from 'src/features/template/components/TemplateTabsHeader'
import { TraceKeysContent } from './components/TraceKeysContent/TraceKeysContent'

/**
 * 検索キー一覧ページ
 * GlobalNavigationとHeaderを含むページレイアウトコンポーネント
 */
const TraceKeysListPage: FC = () => {
  return (
    <GlobalNavigation>
      <TemplateTabsHeader activeTab="traceKeys" />
      <TraceKeysContent />
    </GlobalNavigation>
  )
}

export { TraceKeysListPage }
